export class RequestError extends Error {
    public readonly status?: number;
    public readonly errors?: unknown[];
    public readonly request?: Request;
    public readonly response?: Response;

    /**
     *  Dear @hey-api/client-fetch,
     *  Just because we can throw anything as a error, doesn't mean we should
     *
     *  // https://github.com/hey-api/openapi-ts/blob/main/packages/client-fetch/src/client.ts#L125
     *
     *  let error = await response.text();
     *  try {
     *    error = JSON.parse(error);
     *  } catch {
     *    // noop
     *  }
     *
     *  let finalError = error;
     *
     *  for (const fn of interceptors.error._fns) {
     *    finalError = (await fn(error, response, request, opts)) as string;
     *  }
     *
     *  finalError = finalError || ({} as string);
     *
     *  if (opts.throwOnError) {
     *    throw finalError;
     *  }
     */
    public readonly originalError?: unknown;

    constructor(originalError: unknown, response: Response | undefined, request: Request | undefined) {
        const error = {
            name: 'RequestError',
            status: response?.status,
            message:
                typeof originalError === 'string' || typeof originalError === 'number'
                    ? originalError
                    : response?.statusText,
            ...(typeof originalError === 'object' ? originalError : {}),
            originalError,
            response,
            request,
        };
        super(`${error.message}`);

        // Keep all properties
        Object.assign(this, error);
        Object.setPrototypeOf(this, RequestError.prototype);

        this.name = error.name || 'RequestError';
        this.status = error.status;
    }
}
